import { useGeoContext } from '../contexts/GeoProvider';

const useEligibleUSPayment = (): boolean => {
  const { countryData } = useGeoContext();
  const countryCode = countryData?.countryCode;
  /**
   * Determine country eligibility
   */
  return countryCode === 'US';
};

export default useEligibleUSPayment;
